import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector, useDispatch } from 'react-redux';
import './RevenueAndPayment.css';
import { fetchPaymentDashboardData } from '../../../../redux/reducers/paymentDashboardSlice';
const RevenueAndPayment = () => {
  const dispatch = useDispatch();
  const { revenueReport, paymentModeCounts, loading, error } = useSelector(
    (state) => state.paymentDashboard
  );
  const [period, setPeriod] = useState('YEAR');

  const [revenueSeries, setRevenueSeries] = useState([]);
  const [paymentSeries, setPaymentSeries] = useState([]);

  useEffect(() => {
    dispatch(fetchPaymentDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!revenueReport || !Object.keys(revenueReport).length) return;

    const revenueData = revenueReport[period] || [];

    const revenueMap = { 'Pet Shop': 0, 'Clinic': 0, 'Pharmacy': 0 };
    revenueData.forEach(item => {
      if (revenueMap[item.type] !== undefined) {
        revenueMap[item.type] = parseFloat(item.total) || 0;
      }
    });

    const revenueValues = [
      revenueMap['Pet Shop'],
      revenueMap['Clinic'],
      revenueMap['Pharmacy'],
    ];

    const paymentData = paymentModeCounts[0] || {};
    const paymentValues = [
      parseFloat(paymentData.cash) || 0,
      parseFloat(paymentData.card) || 0,
      parseFloat(paymentData.upi) || 0,
      parseFloat(paymentData.advanceAdjustment) || 0,
    ];

    setRevenueSeries(revenueValues.some(val => val > 0) ? revenueValues : [25000, 45000, 30000]);
    setPaymentSeries(paymentValues.some(val => val > 0) ? paymentValues : [15000, 25000, 35000, 5000]);

  }, [revenueReport, paymentModeCounts, period]);

const revenueOptions = {
  chart: { type: 'pie' },
  labels: ['Pet Shop', 'Clinic', 'Pharmacy'],
  colors: ['#1E3A8A', '#64748B', '#CBD5E1'],
  legend: { show: false },
  dataLabels: { enabled: false },
  tooltip: {
    y: {
      formatter: (value) => value.toFixed(2),
    },
  },
};

  const paymentOptions = {
  chart: { type: 'donut' },
  labels: ['Cash', 'Credit Card', 'UPI', 'Advance Adjustment'],
  colors: ['#1E3A8A', '#93C5FD', '#86EFAC', '#A5F3FC'],
  legend: { show: false },
  dataLabels: { enabled: false },
  tooltip: {
    y: {
      formatter: (value) => value.toFixed(2),
    },
  },
};


  if (loading && !revenueSeries.length) {
    return (
      <div className="revenue-payment-container">
        <div>Loading charts...</div>
      </div>
    );
  }

  return (
    <div className="revenue-payment-container">
      {error && <div className="error-message" style={{color: 'red', marginBottom: '10px'}}>{error}</div>}
      
      <div className="card">
        <div className="card-header">
          <div>
            <h4>Revenue By Source</h4>
            {/* <div className="subtitle"><span className="growth-positive">1.3%</span> vs last year</div> */}
          </div>
          <select value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="WEEK">Week</option>
            <option value="MONTH">Month</option>
            <option value="YEAR">Year</option>
          </select>
        </div>
        <div className="chart-legend-wrapper">
          {revenueSeries.length > 0 && (
            <Chart options={revenueOptions} series={revenueSeries} type="pie" width="240" />
          )}
        
                       <div className="legend">
     {revenueOptions.labels.map((label, idx) => (
      <div key={label}>
        <span className="dot" style={{ backgroundColor: revenueOptions.colors[idx] }}></span>
        {label}
      </div>
    ))}
  </div>

        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h4>Payment Method</h4>
          <select disabled><option>2025</option></select>
        </div>
        <div className="chart-legend-wrapper">
          {paymentSeries.length > 0 && (
            <Chart options={paymentOptions} series={paymentSeries} type="donut" width="240" />
          )}
           <div className="legend">
    {paymentOptions.labels.map((label, idx) => (
      <div key={label}>
        <span className="dot" style={{ backgroundColor: paymentOptions.colors[idx] }}></span>
        {label}
      </div>
    ))}
  </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueAndPayment;